export const selectPiDetailsModal = state => state.piDb.detailsModal
